export default __webpack_public_path__ + "static/media/itunes.4adf295a.svg";